
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  JpCoBenefitoneBsSubsidyDtoErrorData,
  JpCoBenefitoneBsCafeDtoInlineResponse400,
  JpCoBenefitoneBsPointDtoInlineResponse400,
} from '@/openapi/order';
import Icon from '@/layouts/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class ErrorForApiComponent extends Vue {
  @Prop({ type: Object, required: true })
  commonErrorResponse!: JpCoBenefitoneBsSubsidyDtoErrorData;

  @Prop({ type: Array, required: false })
  subsidyErrorResponseList!: JpCoBenefitoneBsSubsidyDtoErrorData[];

  @Prop({ type: Object, required: false })
  cafeErrorResponse!: JpCoBenefitoneBsCafeDtoInlineResponse400;

  @Prop({ type: Object, required: false })
  benepoErrorResponse!: JpCoBenefitoneBsPointDtoInlineResponse400;
}
